<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Service Demand Analysis",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Service Demand Analysis",
      items: [
        {
          text: "Account Section",
          href: "#/",
        },
        {
          text: "Service Demand",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        // {
        //   key: "branch",
        //   sortable: true,
        //   label: "BRANCH",
        // },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "patient_no",
          sortable: true,
          label: "CLIENT NUMBER",
        },
        {
          key: "service_type",
          sortable: true,
          label: "SERVICE CATEGORY",
        },
        {
          key: "service",
          sortable: true,
          label: "SERVICE",
        },
        {
          key: "cost",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "time",
          sortable: true,
          label: "ADDED ON",
        },
      ],
      fitered_array: [],
      // FILTER
      report_filter: {
        datefrom: "",
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        department: "0",
        service: "",
      },
    };
  },
  watch: {
    service_demand(newValue) {
      if (newValue.length > 0) {
        this.service_reportData();
        this.filteranalysis();
      }
    },
  },
  computed: {
    ...mapState("reports", ["service_demand"]),
    ...mapGetters("reports", ["ServiceDemand"]),
    ...mapGetters("services", ["ReportFiltersDepartments"]),

    rows() {
      return this.fitered_array ? this.fitered_array.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.fitered_array ? this.fitered_array.length : 1;
  },

  methods: {
    ...mapActions({
      FetchServiceAnalysis: "reports/fetchServiceAnalysis",
    }),
    localizeDate(date) {
      if (!date || !date.includes("-")) return date;
      const [yyyy, mm, dd] = date.split("-");
      return new Date(`${mm}/${dd}/${yyyy}`);
    },

    service_reportData() {
      this.fitered_array = this.ServiceDemand;
    },

    filteranalysis() {
      let startDate = this.localizeDate(this.report_filter.datefrom);
      let endDate = this.localizeDate(this.report_filter.dateto);
      this.fitered_array = this.ServiceDemand.filter((element) => {
        if (
          this.report_filter.datefrom != "" &&
          this.report_filter.dateto != "" &&
          this.report_filter.department == "0" &&
          this.report_filter.service == ""
        ) {
          return (
            this.localizeDate(element.filter_date) >= startDate &&
            this.localizeDate(element.filter_date) <= endDate
          );
        } else if (
          this.report_filter.datefrom != "" &&
          this.report_filter.dateto != "" &&
          this.report_filter.department != "0" &&
          this.report_filter.service == ""
        ) {
          return (
            this.localizeDate(element.filter_date) >= startDate &&
            this.localizeDate(element.filter_date) <= endDate &&
            element.type == this.report_filter.department
          );
        } else if (
          this.report_filter.datefrom == "" &&
          this.report_filter.dateto != "" &&
          this.report_filter.department != "0" &&
          this.report_filter.service == ""
        ) {
          return (
            this.localizeDate(element.filter_date) <= endDate &&
            element.type == this.report_filter.department
          );
        } else if (
          this.report_filter.datefrom == "" &&
          this.report_filter.dateto != "" &&
          this.report_filter.department == "0" &&
          this.report_filter.service == ""
        ) {
          return this.localizeDate(element.filter_date) <= endDate;
        }
      });
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  created() {
    this.FetchServiceAnalysis();
    this.service_reportData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 form-group">
                <label>FROM</label>
                <input
                  @change="filteranalysis()"
                  v-model="report_filter.datefrom"
                  type="date"
                  class="form-control m-1"
                />
              </div>

              <div class="col-md-4 form-group">
                <label>TO</label>
                <input
                  @change="filteranalysis()"
                  v-model="report_filter.dateto"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>CATEGORY</label>
                <model-list-select
                  @input="filteranalysis()"
                  :list="ReportFiltersDepartments ? ReportFiltersDepartments : []"
                  v-model="report_filter.department"
                  option-value="id"
                  option-text="name"
                  placeholder="select Category"
                >
                </model-list-select>
              </div>
              <!-- <div class="col-md-3 form-group" v-if="report_filter.department != 0">
                <label>SERVICE</label>
                <model-list-select
                  :list="[]"
                  v-model="report_filter.service"
                  option-value="id"
                  option-text="name"
                  placeholder="select service"
                >
                </model-list-select>
              </div> -->
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->

              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->

            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="fitered_array ? fitered_array : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <button @clinc="yes(data)" class="btn btn-primary btn-sm">
                    Details
                  </button>
                </template>
              </b-table>
              <center>
                <h3 v-if="!ServiceDemand" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
